import Vuex from 'vuex'

let Vue = require('vue').default;

Vue.use(Vuex)

import { i18n } from './vue2/langs';

import TestDataDirective from './vue2/directives/testData.js';
Vue.directive('testdata', TestDataDirective);

Vue.component('user-login', require('./vue2/components/auth/UserLogin.vue').default);

class UserLogin {
    constructor () {
        this.instances = [];
    }
    initInstance(instanceId) {
        let config = {
            el: instanceId,
            i18n
        };
        this.instances[instanceId] = (new Vue(config)).$children[0];
    }
    getInstance(instanceId) {
        return this.instances[instanceId];
    }
}
window.UserLogin = new UserLogin();